import { create } from 'zustand';

export interface SubscriptionNotification {
  id: string;
  message: string;
  type: 'success' | 'warning' | 'error' | 'info';
  severity?: 'success' | 'warning' | 'error' | 'info';
  title?: string;
  action?: {
    label: string;
    handler: () => void;
  };
  actionLabel?: string;
  actionUrl?: string;
  timestamp: Date;
}

interface NotificationsState {
  notifications: SubscriptionNotification[];
  addNotification: (
    notification: Omit<SubscriptionNotification, 'id' | 'timestamp'>
  ) => void;
  dismissNotification: (id: string) => void;
  reset: () => void;
}

/**
 * Client-only UI store for transient subscription notifications surfaced
 * through Sonner toasts. Pure client-state (no server fields), kept separate
 * from the Query-backed `cacheKeys.subscriptions.active` per STATE_POLICY.
 */
export const useSubscriptionNotificationsStore = create<NotificationsState>(
  (set) => ({
    notifications: [],
    addNotification: (notification) => {
      const newNotification: SubscriptionNotification = {
        ...notification,
        id: `${Date.now()}-${Math.random()}`,
        timestamp: new Date(),
      };
      set((state) => ({
        notifications: [...state.notifications, newNotification],
      }));
    },
    dismissNotification: (id) => {
      set((state) => ({
        notifications: state.notifications.filter((n) => n.id !== id),
      }));
    },
    reset: () => set({ notifications: [] }),
  })
);
